import { useEffect, useState } from "react";
import { Mail, X } from "lucide-react";
import { api } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { useLanguage } from "../context/LanguageContext";

// One-time newsletter question for brand-new Google sign-ups (they never see the sign-up form).
export const NewsletterAsk = () => {
  const { user } = useAuth();
  const { lang } = useLanguage();
  const fr = lang === "fr";
  const [ask, setAsk] = useState(false);
  useEffect(() => {
    if (!user?.user_id || user.impersonating) return setAsk(false);
    api.get("/me/newsletter").then(({ data }) => setAsk(data.ask)).catch(() => {});
  }, [user?.user_id, user?.impersonating]);
  if (!ask) return null;
  const answer = (join) => { setAsk(false); api.post("/me/newsletter", { join }).catch(() => {}); };
  return (
    <div className="fixed bottom-4 left-4 right-4 sm:right-auto sm:w-[360px] z-50 bg-white rounded-2xl border border-slate-200 shadow-2xl p-5 animate-in slide-in-from-bottom-4 fade-in" data-testid="newsletter-ask">
      <button type="button" onClick={() => answer(false)} className="absolute top-3 right-3 text-slate-400 hover:text-slate-600" aria-label="Close" data-testid="newsletter-ask-close"><X size={16} /></button>
      <span className="h-10 w-10 rounded-xl bg-[#12234A] flex items-center justify-center"><Mail size={18} className="text-[#F5551E]" /></span>
      <p className="font-display font-bold text-[#12234A] mt-3">{fr ? "Recevoir l'infolettre ?" : "Get the CritterPosts newsletter?"}</p>
      <p className="text-sm text-slate-500 mt-1">{fr ? "Nouvelles, conseils et nouveaux animaux, de temps en temps. Désabonnement en tout temps." : "News, tips and new pets now and then. Unsubscribe any time."}</p>
      <div className="mt-4 flex gap-2">
        <button type="button" onClick={() => answer(true)} className="flex-1 h-10 rounded-xl bg-[#F5551E] hover:bg-[#E04812] text-white text-sm font-semibold transition-colors" data-testid="newsletter-ask-yes">{fr ? "Oui, inscrivez-moi" : "Yes, sign me up"}</button>
        <button type="button" onClick={() => answer(false)} className="h-10 px-4 rounded-xl border border-slate-200 text-sm font-semibold text-slate-600 hover:bg-slate-50 transition-colors" data-testid="newsletter-ask-no">{fr ? "Non merci" : "No thanks"}</button>
      </div>
    </div>
  );
};
